import React from 'react';

/**
 * @typedef {object} RadarChartButtonsProps
 * @property {boolean} [isLeftDisabled]
 * @property {boolean} [isRightDisabled]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClickLeft]
 * @property {(event: React.MouseEvent<HTMLButtonElement>) => void} [onClickRight]
 * @property {string} [leftRightId]
 */

/**
 * @param {RadarChartButtonsProps} props
 */
const RadarChartButtons = props => {
  const { isLeftDisabled, isRightDisabled, onClickLeft, onClickRight, leftRightId } = props;

  return (
    <div className='radar-chart-buttons'>
      <button
        id={leftRightId !== undefined ? leftRightId + '-left-button' : ''}
        disabled={isLeftDisabled}
        type='button'
        className={'radar-chart-buttons__left ' + (isLeftDisabled ? 'disabled-arrow' : '')}
        onClick={onClickLeft}>
        &#9668;
      </button>

      <button
        id={leftRightId !== undefined ? leftRightId + '-right-button' : ''}
        disabled={isRightDisabled}
        type='button'
        className={'radar-chart-buttons__right ' + (isRightDisabled ? 'disabled-arrow' : '')}
        onClick={onClickRight}>
        &#9658;
      </button>
    </div>
  );
};

export default RadarChartButtons;
